import { useEffect, useRef } from 'react';

const STORAGE_KEY = 'pendingSearchData';

/**
 * Reads pending search data from sessionStorage (saved before login redirect).
 * Returns the data once if serviceType matches, then removes it.
 *
 * @param {string} serviceType - e.g. 'airport', 'golf', 'ski', etc.
 * @param {function} onRestore - callback receiving the saved data object
 */
export function usePendingSearch(serviceType, onRestore) {
  const restoredRef = useRef(false);

  useEffect(() => {
    if (restoredRef.current) return;
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      const data = JSON.parse(raw);
      if (data.serviceType !== serviceType) return;
      restoredRef.current = true;
      sessionStorage.removeItem(STORAGE_KEY);
      onRestore(data);
    } catch (e) {
      console.warn('[usePendingSearch] 복원 실패:', e.message);
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }, [serviceType, onRestore]);
}
